const i = {
  id: "ArizonaPick3",
  name: "Pick 3",
  style: {
    colorPrimary: "#fdb825"
  }
};
export {
  i as default
};
